"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));

var _CheckboxRadio = _interopRequireDefault(require("../baseComponents/CheckboxRadio"));

var _TextField = _interopRequireDefault(require("../baseComponents/TextField"));

var _Button = _interopRequireDefault(require("../baseComponents/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AssetsManager = function AssetsManager(props) {
  var options = props.options;
  var inputValue = props.textFieldProps.value;

  var renderListItem = function renderListItem(option) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "listItem",
      key: option.value
    }, /*#__PURE__*/_react["default"].createElement("h8", {
      className: option.selected ? "selected" : undefined
    }, " ", option["new"] ? "\"".concat(option.label, "\"") : option.label, " "), option["new"] ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      colorTheme: "teal",
      size: "xsmall",
      shapeStyle: "stroke",
      radius: "square",
      onClick: props.createBtnProps.onClick
    }, props.createBtnProps.label) : /*#__PURE__*/_react["default"].createElement(_CheckboxRadio["default"], {
      type: "checkbox",
      checked: option.selected,
      value: option.value,
      onChange: function onChange(e) {
        props.oncheckboxSelectChanged(e);
      }
    }));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "asset-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-container"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    className: "the-svg-icons",
    name: "glyph-tag",
    type: "glyph"
  })), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    fieldStyle: "text-field-outline",
    placeholder: props.textFieldProps.placeholder,
    value: props.textFieldProps.value,
    onChange: function onChange(e) {
      return props.textFieldProps.onChange(e);
    }
  }), inputValue && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-remove",
    onClick: function onClick(e) {
      e.stopPropagation();
      props.clearSelection();
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "optionsListingContainer"
  }, /*#__PURE__*/_react["default"].createElement("div", null, options.length == 1 && options[0]["new"] || options.length === 0 ? props.noAssetHeader : props.chooseAssetHeader), options.map(function (option) {
    return renderListItem(option);
  }))), props.manageBtnProps.show ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    ccolorTheme: "teal",
    shapeStyle: "stroke",
    radius: "square",
    onClick: props.manageBtnProps.onClick
  }, props.manageBtnProps.label) : null);
};

AssetsManager.propTypes = {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
    selected: _propTypes["default"].bool
  })),
  createBtnProps: _propTypes["default"].shape({
    onClick: _propTypes["default"].func.isRequired,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired
  }).isRequired,
  oncheckboxSelectChanged: _propTypes["default"].func.isRequired,
  textFieldProps: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
    placeholder: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
    setValue: _propTypes["default"].func.isRequired
  }).isRequired,
  noAssetHeader: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  chooseAssetHeader: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  clearSelection: _propTypes["default"].func.isRequired,
  manageBtnProps: _propTypes["default"].shape({
    onClick: _propTypes["default"].func,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])
  })
};
AssetsManager.defaultProps = {
  options: [],
  manageBtnProps: {
    show: false,
    onClick: function onClick() {},
    label: ""
  }
};
var _default = AssetsManager;
exports["default"] = _default;